import { axios, url } from "@/plugin/axios";

export default {
  index() {
    return axios.get(`${url}admin/users/locations`);
  }
};
